/***************************************** INITIAL STATE ********************************************/
const INITIAL_SNIPPET = {
    name: '',
    content: '',
    patternsList: [],
    language: '',
}

const INITIAL_SNIPPETS = {
    firstSnippet: INITIAL_SNIPPET,
    secondSnippet: INITIAL_SNIPPET,
}

export const INITIAL_STATE = {
    showModal: false,
    snippets: INITIAL_SNIPPETS,
}

/***************************************** ACTION TYPES *********************************************/
const reducerName = 'COMPARE_SNIPPETS_'
const actionTypes = {
    SET_SHOW_MODAL: `${reducerName}SET_SHOW_MODAL`,
    SET_FIRST_SNIPPET: `${reducerName}SET_FIRST_SNIPPET`,
    SET_SECOND_SNIPPET: `${reducerName}SET_SECOND_SNIPPET`,
}

/******************************************** ACTIONS ***********************************************/
export const actions = {
    setShowModal: value => ({
        type: actionTypes.SET_SHOW_MODAL,
        payload: { value },
    }),
    setFirstSnippet: value => ({
        type: actionTypes.SET_FIRST_SNIPPET,
        payload: { value },
    }),
    setSecondSnippet: value => ({
        type: actionTypes.SET_SECOND_SNIPPET,
        payload: { value },
    }),
}

/******************************************* REDUCER ************************************************/
const compareSnippetsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SET_SHOW_MODAL:
            return {
                ...state,
                showModal: action.payload.value,
            }

        case actionTypes.SET_FIRST_SNIPPET:
            return {
                ...state,
                snippets: {
                    ...state.snippets,
                    firstSnippet: action.payload.value,
                },
            }

        case actionTypes.SET_SECOND_SNIPPET:
            return {
                ...state,
                snippets: {
                    ...state.snippets,
                    secondSnippet: action.payload.value,
                },
            }

        default:
            return state
    }
}

export default compareSnippetsReducer
